/**
 * 客户类型常量定义
 */

// 客户类型枚举
export const CUSTOMER_TYPES = {
  PERSONAL: '个人客户',
  INSTITUTIONAL: '建行',
  EXTERNAL: '外部机构',
} as const;

// 客户类型选项
export const CUSTOMER_TYPE_OPTIONS = [
  { value: CUSTOMER_TYPES.PERSONAL, label: CUSTOMER_TYPES.PERSONAL },
  { value: CUSTOMER_TYPES.INSTITUTIONAL, label: CUSTOMER_TYPES.INSTITUTIONAL },
  { value: CUSTOMER_TYPES.EXTERNAL, label: CUSTOMER_TYPES.EXTERNAL },
];

// 客户类型颜色映射
export const CUSTOMER_TYPE_COLORS = {
  [CUSTOMER_TYPES.PERSONAL]: 'blue',
  [CUSTOMER_TYPES.INSTITUTIONAL]: 'green',
  [CUSTOMER_TYPES.EXTERNAL]: 'orange',
} as const;

// 客户类型图标映射
export const CUSTOMER_TYPE_ICONS = {
  [CUSTOMER_TYPES.PERSONAL]: 'UserOutlined',
  [CUSTOMER_TYPES.INSTITUTIONAL]: 'BankOutlined',
  [CUSTOMER_TYPES.EXTERNAL]: 'GlobalOutlined',
} as const;

// 客户类型描述
export const CUSTOMER_TYPE_DESCRIPTIONS = {
  [CUSTOMER_TYPES.PERSONAL]: '个人身份的自然人客户',
  [CUSTOMER_TYPES.INSTITUTIONAL]: '企业、组织等法人客户',
  [CUSTOMER_TYPES.EXTERNAL]: '外部合作机构或第三方机构',
} as const;

// 客户类型类型定义
export type CustomerType = typeof CUSTOMER_TYPES[keyof typeof CUSTOMER_TYPES];
